export const AudienceInterestsAPIService = {
    getApiEndpoint: () => {
        return "/api/websiteanalysis/GetAudienceInterestsTable";
    },
};
